// extracted by mini-css-extract-plugin
export var disabled = "_1l-5";
export var error = "_1l-1";
export var fitContent = "_1l-6";
export var hasSuffix = "_1l-4";
export var iconWrapper = "_1l-b";
export var infoIconWrapper = "_1l-d _1l-b";
export var input = "_1l-a";
export var inputWrapper = "_1l-0";
export var large = "_1l-8";
export var leadingIconWrapper = "_1l-c _1l-b";
export var measureBox = "_1l-e";
export var medium = "_1l-7";
export var readonly = "_1l-2";
export var small = "_1l-3";
export var suffix = "_1l-9";